// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"Checkbox__checkbox___1jipC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Checkbox.scss
// module id = K10Q
// module chunks = 0